@if (canView) {
  <div class="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">

    <!-- Help panel -->
    @if (isOpen) {
      <div
        class="w-80 rounded-xl border shadow-2xl overflow-hidden bg-white"
        style="border-color: var(--color-border);"
        role="dialog"
        aria-label="EVE Help"
        aria-modal="true"
      >
        <!-- Panel header -->
        <div
          class="flex items-center justify-between px-4 py-3 border-b"
          style="background: var(--color-primary); border-color: var(--color-primary-dark);"
        >
          <div class="flex items-center gap-2">
            <span class="text-sm font-semibold" style="color: var(--color-text-inverse);">EVE Help</span>
            <span
              class="text-xs px-2 py-0.5 rounded-full font-medium"
              style="background: rgba(255,255,255,0.2); color: var(--color-text-inverse);"
            >AI-generated</span>
          </div>
          <button
            type="button"
            class="transition-opacity hover:opacity-100 opacity-75"
            style="color: var(--color-text-inverse);"
            aria-label="Close help panel"
            (click)="toggle()"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <!-- Question input -->
        <div class="p-4 border-b" style="border-color: var(--color-border);">
          <div class="flex gap-2">
            <input
              type="text"
              class="input flex-1"
              style="padding: 8px 12px; font-size: var(--text-sm); margin-top: 0;"
              placeholder="Ask anything about EVE…"
              [(ngModel)]="question"
              (keydown.enter)="submit()"
              [disabled]="loading"
              aria-label="Help question"
            />
            <button
              type="button"
              class="btn"
              style="padding: 8px 14px; font-size: var(--text-sm);"
              (click)="submit()"
              [disabled]="loading || !question.trim() || !canExecute"
            >
              Ask
            </button>
          </div>
        </div>

        <!-- Response area -->
        <div class="p-4 max-h-64 overflow-y-auto">
          @if (loading) {
            <div class="flex items-center gap-2" style="color: var(--color-text-muted); font-size: var(--text-sm);">
              <svg class="animate-spin w-4 h-4" style="color: var(--color-accent);" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25"/>
                <path fill="currentColor" opacity="0.75" d="M4 12a8 8 0 018-8v8H4z"/>
              </svg>
              <span>Thinking…</span>
            </div>
          } @else if (error) {
            <p style="font-size: var(--text-sm); color: var(--color-rating-low);">
              Unable to get help right now. Please try again.
            </p>
          } @else if (helpResponse) {
            <p
              class="whitespace-pre-wrap leading-relaxed"
              style="font-size: var(--text-sm); color: var(--color-text-primary);"
            >{{ helpResponse.text }}</p>

            @if (helpResponse.relatedLinks?.length) {
              <div
                class="mt-3 pt-3 border-t flex flex-col items-start gap-1"
                style="border-color: var(--color-border);"
              >
                <span
                  class="font-medium"
                  style="font-size: var(--text-xs); color: var(--color-text-muted);"
                >Related pages</span>
                @for (link of helpResponse.relatedLinks; track link) {
                  <button
                    type="button"
                    data-testid="related-link"
                    class="text-left hover:underline"
                    style="font-size: var(--text-sm); color: var(--color-text-link);"
                    (click)="onLinkClick(link)"
                  >{{ link }}</button>
                }
              </div>
            }

          } @else {
            <p
              class="italic"
              style="font-size: var(--text-sm); color: var(--color-text-muted);"
            >Ask a question to get contextual help for the current page.</p>
          }
        </div>
      </div>
    }

    <!-- Trigger button -->
    <button
      type="button"
      class="w-12 h-12 rounded-full text-white font-bold text-xl shadow-lg transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2"
      style="background: var(--color-primary); focus-ring-color: var(--color-primary);"
      aria-label="Open EVE Help"
      [attr.aria-expanded]="isOpen"
      (click)="toggle()"
    >?</button>

  </div>
}
